export default __webpack_public_path__ + "static/cp-green-1f2a310576bad0ece99cf9d46e9899ac.png";